import { prepareValue } from '../../shared/services/opening-form-services'

const I_JOIST_BRANDS = ['lpi', 'bci', 'tji', 'pwi', 'ajs'] as const

type IJoistBrand = (typeof I_JOIST_BRANDS)[number]

/**
 * Normalizes brand-specific i-joist settings to standard `series` and `ijoist_size` fields.
 * Maps `{brand}_series` to `series` and `ijoist_size_{brand}` to `ijoist_size`,
 * then removes the brand-specific properties.
 *
 * @param newSettings - The settings object to modify (mutated in place)
 */
export function normalizeIJoistBrandSettings(newSettings: Record<string, string | number>): void {
    const brand = prepareValue(newSettings.brand) as IJoistBrand

    if (!I_JOIST_BRANDS.includes(brand)) {
        return
    }

    const seriesKey = `${brand}_series` as const
    const iJoistSizeKey = `ijoist_size_${brand}` as const

    if (newSettings[seriesKey]) {
        newSettings.series = newSettings[seriesKey]
        delete newSettings[seriesKey]
    }

    newSettings.ijoist_size = newSettings[iJoistSizeKey]
    delete newSettings[iJoistSizeKey]
}
